export default "__VITE_ASSET__qdPOUK$w__"